export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
